"use client";

import StockNewsSectionContent from "./stock-news-section-content";
import { trpcApi } from "@lattice/frontend/lib/trpc/client/index";

export default function StockNewsSection({
  symbol,
  is_crypto,
}: {
  symbol: string;
  is_crypto: boolean;
}) {
  const [data] = trpcApi.stock.get_news.useSuspenseQuery({
    symbols: [is_crypto ? symbol + "/USD" : symbol],
  });

  return <StockNewsSectionContent news={data} />;
}
